/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Event_TemplatesInputs */



/**
* | output |
* | --- |
* | "Event Templates" |
*
* @param {Options_Quicktools_Event_TemplatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_event_templates = /** @type {((inputs?: Options_Quicktools_Event_TemplatesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Event_TemplatesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modèles d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisvorlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modelli di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Шаблоны мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plantillas de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテンプレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेम्प्लेट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modelos de eventos")
	return /** @type {LocalizedString} */ ("Event Templates")
});